/* Cardify taalwissel: Nederlands, Engels, Duits.
 *
 * Nederlands is de brontaal en staat als gewone tekst in de HTML.
 * Engels staat per element in data-en / data-en-html.
 * Duits komt uit een woordenboek (cardify-woordenboek-de.js) dat de
 * Nederlandse brontekst opzoekt. Dat scheelt een derde attribuut op elk
 * element en houdt de HTML klein; het woordenboek wordt alleen geladen
 * als iemand daadwerkelijk Duits kiest.
 *
 * Vier soorten attributen:
 *   data-nl / data-en                    platte tekst, via textContent
 *   data-nl-html / data-en-html          tekst met opmaak, via innerHTML
 *   data-attr-placeholder-nl / -en       placeholder van een invoerveld
 *   data-attr-titel-nl / -en             title-attribuut
 *
 * BELANGRIJK: de starttaal komt van de server (Shopify.locale), niet van
 * navigator.language. Anders krijgt een crawler die met een Engelse locale
 * rendert, zoals Googlebot, de Engelse tekst te zien op een Nederlandse URL
 * met Nederlandse metadata eromheen. Alleen een expliciete klik van de
 * bezoeker wijkt daarvan af; die keuze wordt onthouden in localStorage.
 *
 * navigator.language wordt nog op een plek gebruikt: om een Duitstalige
 * bezoeker eenmalig te vragen of hij Duits wil. De pagina wisselt daarbij
 * niet vanzelf, want tekst en metadata van een URL horen bij elkaar te
 * blijven.
 */
(function () {
  var TALEN = ["nl", "en", "de"];
  var woordenboek = null;      // NL -> DE, pas geladen als het nodig is
  var wachtOpWoordenboek = false;

  /* Het woordenboek staat naast dit bestand in dezelfde assets-map. Het pad
     wordt hier afgeleid van de eigen script-src, zodat er niets in de liquid
     hoeft te worden bijgehouden. currentScript is alleen geldig zolang het
     script draait, dus we leggen het meteen vast. */
  var EIGEN_SRC = (document.currentScript && document.currentScript.src) || "";

  /* Shopify zet dit serverzijdig in content_for_header: "nl" op de hoofdsite,
     "en" op /en/. Dat is precies het signaal dat we willen, want het hoort bij
     de URL en bij de metadata van de pagina. */
  function serverTaal() {
    var t = "nl";
    try { t = (window.Shopify && window.Shopify.locale) || "nl"; } catch (e) {}
    t = String(t).toLowerCase().slice(0, 2);
    return TALEN.indexOf(t) === -1 ? "nl" : t;
  }

  function gekozenTaal() {
    try { return localStorage.getItem("cf-taal-keuze"); } catch (e) { return null; }
  }

  /* Teksten die het thema met een getal of een datum opbouwt, staan niet als
     vaste zin in het woordenboek. Voor die handvol patronen doen we het met
     een reguliere expressie, zodat elk getal werkt in plaats van alleen de
     getallen die toevallig op de site stonden toen dit werd gemaakt. */
  var MAANDEN = {
    januari: "Januar", februari: "Februar", maart: "März", april: "April",
    mei: "Mai", juni: "Juni", juli: "Juli", augustus: "August",
    september: "September", oktober: "Oktober", november: "November", december: "Dezember"
  };
  var PATRONEN = [
    [/^(\d+) resultaten · (\d+) op voorraad$/, "$1 Ergebnisse · $2 auf Lager"],
    [/^(\d+) resultaten$/, "$1 Ergebnisse"],
    [/^Toon alle (\d+) kaarten$/, "Alle $1 Karten anzeigen"],
    [/^Toon alle (\d+) producten$/, "Alle $1 Produkte anzeigen"],
    [/^(\d+) kaarten$/, "$1 Karten"],
    [/^(\d+) van de (\d+) bekend$/, "$1 von $2 bekannt"],
    [/^(\d+) boosterpakjes$/, "$1 Boosterpacks"],
    [/^· (\d+) chase$/, "· $1 Chase"],
    [/^Nog (\d+) op voorraad$/, "Nur noch $1 auf Lager"],
    [/^(\d{4}) · (\d+) kaarten$/, "$1 · $2 Karten"]
  ];

  function patroonVertaal(nl) {
    for (var i = 0; i < PATRONEN.length; i++) {
      if (PATRONEN[i][0].test(nl)) return nl.replace(PATRONEN[i][0], PATRONEN[i][1]);
    }
    // "Verwacht rond 28 september 2026" en varianten met een maandnaam
    var m = nl.match(/^Verwacht rond (\d+) ([a-zé]+) (\d{4})(.*)$/i);
    if (m && MAANDEN[m[2].toLowerCase()]) {
      return "Erwartet um den " + m[1] + ". " + MAANDEN[m[2].toLowerCase()] + " " + m[3] + m[4];
    }
    var d = nl.match(/^Laatst bijgewerkt: (\d+) ([a-zé]+) (\d{4})$/i);
    if (d && MAANDEN[d[2].toLowerCase()]) {
      return "Zuletzt aktualisiert: " + d[1] + ". " + MAANDEN[d[2].toLowerCase()] + " " + d[3];
    }
    return null;
  }

  function vertaal(nl, taal) {
    if (taal !== "de") return nl;
    if (!woordenboek) return nl;
    var d = woordenboek[nl];
    if (typeof d === "string" && d.length) return d;
    var p = patroonVertaal(nl.trim());
    return p !== null ? p : nl;
  }

  function pasToe(taal) {
    if (TALEN.indexOf(taal) === -1) taal = "nl";

    // Duits heeft het woordenboek nodig; laad het en kom terug.
    if (taal === "de" && !woordenboek) {
      laadWoordenboek(function () { pasToe("de"); });
      return;
    }

    document.querySelectorAll("[data-nl][data-en]").forEach(function (el) {
      var nl = el.getAttribute("data-nl");
      el.textContent = taal === "en" ? el.getAttribute("data-en") : vertaal(nl, taal);
    });
    document.querySelectorAll("[data-nl-html][data-en-html]").forEach(function (el) {
      var nl = el.getAttribute("data-nl-html");
      el.innerHTML = taal === "en" ? el.getAttribute("data-en-html") : vertaal(nl, taal);
    });
    document.querySelectorAll("[data-attr-placeholder-nl]").forEach(function (el) {
      var nl = el.getAttribute("data-attr-placeholder-nl");
      el.setAttribute("placeholder", taal === "en" ? el.getAttribute("data-attr-placeholder-en") : vertaal(nl, taal));
    });
    document.querySelectorAll("[data-attr-titel-nl]").forEach(function (el) {
      var nl = el.getAttribute("data-attr-titel-nl");
      el.setAttribute("title", taal === "en" ? el.getAttribute("data-attr-titel-en") : vertaal(nl, taal));
    });

    vulAntwoordblok(taal);
    vertaalLosseBlokken(taal);
    vertaalPatroonLabels(taal);
    document.documentElement.setAttribute("lang", taal);
    knoppenBij(taal);
    window.CardifyI18n.taal = taal;
    document.dispatchEvent(new CustomEvent("cf:taal", { detail: { taal: taal } }));
  }

  /* De antwoordpagina's onder /pages/vragen/ zijn metaobjecten: hun tekst komt
     niet uit het thema en draagt dus geen data-nl. Het thema zet wel twee
     kant-en-klare versies in de pagina, als script-templates #cfv-uitleg-nl en
     #cfv-uitleg-en, maar gebruikte ze tot nu toe niet: bij Engels bleef de
     Nederlandse uitleg staan onder een Engelse kop. Hier zetten we de juiste
     versie wel, en voor Duits vertalen we de Nederlandse blok voor blok.

     Wordt een blok niet in het woordenboek gevonden, dan blijft het staan zoals
     het stond: liever een Nederlandse alinea dan een halve vertaling. */
  function templateInhoud(taal) {
    var el = document.getElementById("cfv-uitleg-" + taal);
    return el ? el.textContent : null;
  }

  function vulAntwoordblok(taal) {
    var body = document.querySelector(".cfv-body");
    if (!body) return;
    // Voor Duits vertrekken we vanuit het Nederlands en vertalen we per blok.
    var basis = (taal === "en") ? "en" : "nl";
    var inhoud = templateInhoud(basis);
    if (inhoud !== null && body.innerHTML.trim() !== inhoud.trim()) {
      body.innerHTML = inhoud;
    }
    if (taal !== "de" || !woordenboek) return;
    var blokken = body.querySelectorAll("h2, h3, p, li");
    blokken.forEach(function (el) {
      var nu = el.innerHTML.trim();
      var d = woordenboek[nu];
      if (typeof d === "string" && d.length) el.innerHTML = d;
    });
  }

  /* Het korte antwoord en de afsluitregel dragen wel data-nl en zijn dus al
     door pasToe behandeld; alleen Duits heeft hier nog het woordenboek nodig
     voor blokken zonder attribuut. */
  function vertaalLosseBlokken(taal) {
    if (taal !== "de" || !woordenboek) return;
    document.querySelectorAll(".cfv-antwoord p, .cfv-uitgang, .cfv-uitgang p").forEach(function (el) {
      if (el.hasAttribute("data-nl")) return;
      var nu = el.innerHTML.trim();
      var d = woordenboek[nu];
      if (typeof d === "string" && d.length) el.innerHTML = d;
    });
  }

  /* Tekst die niet uit het thema komt en dus geen data-nl draagt: de
     beschrijving van een collectie, een sectietekst uit de winkelinstellingen,
     of een label dat met een getal is opgebouwd. We vervangen alleen als de
     hele tekstknoop exact in het woordenboek staat of volledig op een bekend
     patroon past, zodat er nooit halve zinnen ontstaan. */
  function vertaalPatroonLabels(taal) {
    if (taal !== "de") return;
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var doen = [], n;
    while ((n = w.nextNode())) {
      var t = n.textContent.trim();
      if (t.length < 4 || t.length > 400) continue;
      var el = n.parentElement;
      if (!el || el.closest("script,style,noscript")) continue;
      if (el.hasAttribute("data-nl")) continue;
      var d = woordenboek ? woordenboek[t] : null;
      if (typeof d !== "string" || !d.length) d = patroonVertaal(t);
      if (d !== null && d !== t) doen.push([n, d, t]);
    }
    doen.forEach(function (x) {
      x[0].textContent = x[0].textContent.replace(x[2], x[1]);
    });
  }

  /* Alleen een klik van de bezoeker wordt onthouden. */
  function kies(taal) {
    try { localStorage.setItem("cf-taal-keuze", taal); } catch (e) {}
    verbergHint();
    pasToe(taal);
  }

  function laadWoordenboek(klaar) {
    if (woordenboek) { klaar(); return; }
    if (wachtOpWoordenboek) { document.addEventListener("cf:woordenboek", klaar, { once: true }); return; }
    wachtOpWoordenboek = true;
    var bron = EIGEN_SRC.replace(/cardify-i18n\.js/, "cardify-woordenboek-de.js");
    if (!bron || bron === EIGEN_SRC) { wachtOpWoordenboek = false; woordenboek = {}; klaar(); return; }
    var s = document.createElement("script");
    s.src = bron;
    s.onload = function () {
      woordenboek = window.CardifyWoordenboekDE || {};
      wachtOpWoordenboek = false;
      document.dispatchEvent(new Event("cf:woordenboek"));
      klaar();
    };
    s.onerror = function () {
      // Woordenboek onbereikbaar: blijf op de brontaal staan in plaats van half te vertalen.
      woordenboek = {};
      wachtOpWoordenboek = false;
      document.dispatchEvent(new Event("cf:woordenboek"));
      klaar();
    };
    document.head.appendChild(s);
  }

  /* De Duitse knop wordt naast de bestaande knoppen gezet door de Engelse te
     klonen. Zo hoeft geen enkel sjabloon aangepast te worden en verschijnt hij
     overal waar de taalkiezer al staat: in de header en in de mobiele lade. */
  function bouwDuitseKnop() {
    document.querySelectorAll('[data-taal-kies="en"]').forEach(function (en) {
      if (en.parentNode.querySelector('[data-taal-kies="de"]')) return;
      var de = en.cloneNode(true);
      de.setAttribute("data-taal-kies", "de");
      de.textContent = "DE";
      if (en.id) de.id = en.id.replace("-en", "-de");
      en.parentNode.insertBefore(de, en.nextSibling);
    });
  }

  function knoppenBij(taal) {
    TALEN.forEach(function (t) {
      document.querySelectorAll('[data-taal-kies="' + t + '"]').forEach(function (b) {
        var actief = (t === taal);
        b.style.background = actief ? "#CFF84A" : "transparent";
        b.style.color = actief ? "#111110" : "#6B6B62";
        b.setAttribute("aria-current", actief ? "true" : "false");
      });
    });
  }

  /* Een bezoeker met een Duitse browser krijgt een klein aanbod te zien, maar
     de pagina wisselt niet vanzelf: de tekst en de metadata van deze URL horen
     bij elkaar te blijven. */
  var hint = null;
  function toonHint() {
    if (hint) return;
    hint = document.createElement("div");
    hint.setAttribute("role", "status");
    hint.style.cssText = "position:fixed;left:50%;transform:translateX(-50%);bottom:calc(16px + env(safe-area-inset-bottom));z-index:9999;display:flex;align-items:center;gap:12px;max-width:calc(100vw - 32px);background:#111110;color:#F7F6F1;border-radius:14px;padding:12px 14px;box-shadow:0 10px 30px rgba(17,17,16,.28);font-family:'Space Grotesk',sans-serif;font-size:14px;line-height:1.4";
    var tekst = document.createElement("span");
    tekst.textContent = "Diese Seite auf Deutsch lesen?";
    var ja = document.createElement("button");
    ja.type = "button";
    ja.textContent = "Auf Deutsch";
    ja.style.cssText = "flex:none;border:0;border-radius:9px;background:#CFF84A;color:#111110;font:inherit;font-weight:700;padding:9px 12px;cursor:pointer;min-height:40px";
    ja.addEventListener("click", function () { kies("de"); });
    var nee = document.createElement("button");
    nee.type = "button";
    nee.setAttribute("aria-label", "Schließen");
    nee.textContent = "✕";
    nee.style.cssText = "flex:none;border:0;background:transparent;color:#B9B9AE;font:inherit;font-size:16px;padding:8px;cursor:pointer;min-height:40px;min-width:40px";
    nee.addEventListener("click", function () {
      try { localStorage.setItem("cf-taal-hint", "weg"); } catch (e) {}
      verbergHint();
    });
    hint.appendChild(tekst); hint.appendChild(ja); hint.appendChild(nee);
    document.body.appendChild(hint);
  }
  function verbergHint() {
    if (hint && hint.parentNode) hint.parentNode.removeChild(hint);
    hint = null;
  }

  function misschienHint(huidig) {
    if (huidig === "de" || gekozenTaal()) return;
    var weg = null;
    try { weg = localStorage.getItem("cf-taal-hint"); } catch (e) {}
    if (weg) return;
    var browser = (navigator.language || "").toLowerCase();
    if (browser.indexOf("de") !== 0) return;
    toonHint();
  }

  /* Sommige onderdelen schrijven hun eigen tekst terug nadat wij vertaald
     hebben: de aankondigingsbalk rouleert elke paar seconden door drie
     meldingen, en de winkelmand bouwt zijn regels opnieuw op. We kijken mee en
     vertalen zo'n stuk opnieuw zodra het verandert. */
  function bewaakDynamischeDelen() {
    if (typeof MutationObserver === "undefined") return;
    var doelen = ["#cf-aankondiging", "[data-cf-mand]", "#cf-mand", ".cf-mandrij"];
    var bezig = false;
    var obs = new MutationObserver(function () {
      if (bezig || window.CardifyI18n.taal !== "de" || !woordenboek) return;
      bezig = true;
      // in een microtask, zodat we niet in onze eigen wijziging terechtkomen
      Promise.resolve().then(function () {
        document.querySelectorAll("[data-nl][data-en]").forEach(function (el) {
          var nl = el.getAttribute("data-nl");
          var d = woordenboek[nl];
          if (typeof d === "string" && d.length && el.textContent !== d) el.textContent = d;
        });
        vertaalPatroonLabels("de");
        bezig = false;
      });
    });
    doelen.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        obs.observe(el, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["data-nl"] });
      });
    });
  }

  function init() {
    var taal = gekozenTaal() || serverTaal();
    bouwDuitseKnop();
    pasToe(taal);
    misschienHint(taal);
    bewaakDynamischeDelen();
  }

  window.CardifyI18n = { taal: "nl", zet: kies, talen: TALEN };
  document.addEventListener("click", function (e) {
    var el = e.target.closest("[data-taal-kies]");
    if (el) kies(el.getAttribute("data-taal-kies"));
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
